// Stock limits include all cart lines for a variant, including repeat additions.
function productStock(section) {
  try { return JSON.parse(section.querySelector('[data-stock-variants]')?.textContent || '[]'); }
  catch { return []; }
}
function applyStockLimits(section) {
  const form = section.querySelector('[data-product-form]');
  if (!form) return;
  const variant = productStock(section).find((item) => String(item.id) === form.elements.id.value);
  if (!variant) return;
  const input = form.elements.quantity;
  const remaining = variant.limit === null ? null : Math.max(0, variant.limit - variant.inCart);
  if (remaining === null) input.removeAttribute('max');
  else input.max = String(remaining);
  input.min = String(variant.min);
  input.step = String(variant.step);
  const button = form.querySelector('[data-add-to-cart]');
  const full = remaining !== null && remaining < variant.min;
  button.disabled = !variant.available || full;
  button.textContent = !variant.available || (full && !variant.inCart) ? 'Sold out' : full ? 'Maximum quantity in cart' : 'Add to cart';
  const message = form.querySelector('[data-stock-message]');
  if (message) message.textContent = remaining === null ? '' : full ? variant.inCart ? 'You already have the available quantity in your cart.' : 'This item is currently out of stock.' : `You can add up to ${remaining}${variant.inCart ? ` more (${variant.inCart} already in your cart)` : ''}.`;
}
async function refreshProductStock(section) {
  const url = section.dataset.productUrl;
  if (!url) return;
  const root = document.body.dataset.rootUrl || '/';
  const [stockResponse, cartResponse] = await Promise.all([
    fetch(`${url}?section_id=product-stock`, { cache: 'no-store' }),
    fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
  ]);
  if (!stockResponse.ok || !cartResponse.ok) throw new Error('Unable to check stock. Please try again.');
  const parsed = new DOMParser().parseFromString(await stockResponse.text(), 'text/html');
  const source = parsed.querySelector('[data-stock-variants]');
  if (!source) throw new Error('Unable to check stock. Please refresh the page.');
  const variants = JSON.parse(source.textContent);
  const cart = await cartResponse.json();
  variants.forEach((variant) => { variant.inCart = cart.items.filter((item) => String(item.variant_id) === String(variant.id)).reduce((sum, item) => sum + item.quantity, 0); });
  section.querySelector('[data-stock-variants]').textContent = JSON.stringify(variants);
  applyStockLimits(section);
}
function initializeProducts(root = document) {
  const sections = [...root.querySelectorAll('[data-product-section]')];
  if (root.matches?.('[data-product-section]')) sections.unshift(root);
  sections.forEach((section) => {
    applyStockLimits(section);
    const select = section.querySelector('[data-variant-select]');
    if (!select || select.dataset.initialized) return;
    select.dataset.initialized = 'true';
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = section.querySelector('[data-variant-price]');
      price.textContent = option.dataset.price;
      if (option.dataset.compare) {
        const previous = document.createElement('s');
        previous.textContent = option.dataset.compare;
        price.append(' ', previous);
      }
      const button = section.querySelector('[data-add-to-cart]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
      const quantity = section.querySelector('[name="quantity"]');
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.increment || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      applyStockLimits(section);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      if (option.dataset.media) document.getElementById(option.dataset.media)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  });
}
initializeProducts();
document.addEventListener('shopify:section:load', (event) => initializeProducts(event.target));
let cartOpener;
function openCart() {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer?.showModal) return false;
  cartOpener = document.activeElement;
  drawer.showModal();
  drawer.addEventListener('close', () => cartOpener?.focus(), { once: true });
  return true;
}
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-open]')) {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (openCart()) event.preventDefault();
  }
  if (event.target.closest('[data-cart-close]')) document.getElementById('CartDrawer')?.close();
  const drawer = document.getElementById('CartDrawer');
  if (event.target === drawer) {
    const bounds = drawer.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
  }
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form || !document.getElementById('CartDrawer')?.showModal) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-to-cart]');
  const error = form.querySelector('[data-product-error]');
  if (form.dataset.busy) return;
  form.dataset.busy = 'true';
  error.hidden = true;
  button.disabled = true;
  button.textContent = 'Adding…';
  let added = false;
  const root = document.body.dataset.rootUrl || '/';
  const section = form.closest('[data-product-section]');
  try {
    await refreshProductStock(section);
    if (button.disabled || !form.reportValidity()) return;
    button.disabled = true;
    button.textContent = 'Adding…';
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    const response = await fetch(`${root}cart/add.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
    added = true;
    await refreshProductStock(section);
    if (!result.sections?.['cart-drawer']) { window.location.assign(`${root}cart`); return; }
    const parsed = new DOMParser().parseFromString(result.sections['cart-drawer'], 'text/html');
    const updated = parsed.getElementById('CartDrawer');
    if (!updated) { window.location.assign(`${root}cart`); return; }
    document.getElementById('CartDrawer').replaceWith(updated);
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = updated.dataset.cartCountValue;
      count.closest('[data-cart-open]')?.setAttribute('aria-label', `Cart, ${updated.dataset.cartCountValue} items`);
    });
    openCart();
  } catch (failure) {
    if (added) { window.location.assign(`${root}cart`); return; }
    // Shopify may adjust the cart even when an add returns an inventory error.
    try { await refreshProductStock(section); } catch { /* Preserve the original error. */ }
    error.textContent = failure.message || 'Unable to add this item. Please try again.';
    error.hidden = false;
  } finally {
    delete form.dataset.busy;
    const selected = form.querySelector('[data-variant-select]')?.selectedOptions[0];
    button.disabled = selected ? selected.dataset.available !== 'true' : false;
    button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
    applyStockLimits(section);
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const opened = document.activeElement?.closest('details[open]');
    if (opened) { opened.open = false; opened.querySelector('summary')?.focus(); }
  }
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('#CartForm');
  if (!form || form.dataset.stockChecked === 'true') return;
  event.preventDefault();
  if (form.dataset.busy) return;
  form.dataset.busy = 'true';
  const submitter = event.submitter;
  const error = form.querySelector('[data-cart-error]');
  error.hidden = true;
  try {
    const root = document.body.dataset.rootUrl || '/';
    const response = await fetch(`${root}cart?section_id=cart-stock`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check stock. Please try again.');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const stock = parsed.querySelector('[data-cart-stock]');
    if (!stock) throw new Error('Unable to check stock. Please refresh the page.');
    const variants = JSON.parse(stock.textContent);
    const inputs = [...form.querySelectorAll('[name="updates[]"]')];
    for (const variant of variants) {
      const total = inputs.filter((input) => input.dataset.variantId === String(variant.id)).reduce((sum, input) => sum + Number(input.value), 0);
      if (variant.limit !== null && total > variant.limit) throw new Error(`Only ${variant.limit} available for ${variant.title}. Please reduce the quantity.`);
    }
    form.dataset.stockChecked = 'true';
    form.requestSubmit(submitter);
    delete form.dataset.stockChecked;
  } catch (failure) {
    error.textContent = failure.message;
    error.hidden = false;
    error.scrollIntoView({ block: 'center' });
  } finally { delete form.dataset.busy; }
});
function initializeTrustpilot() {
  const widgets = document.querySelectorAll('[data-trustpilot]');
  if (!widgets.length) return;
  const load = () => widgets.forEach((widget) => window.Trustpilot?.loadFromElement(widget, true));
  if (window.Trustpilot) { load(); return; }
  if (document.querySelector('[data-trustpilot-script]')) return;
  const script = document.createElement('script');
  script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  script.async = true;
  script.dataset.trustpilotScript = '';
  script.onload = load;
  document.head.append(script);
}
initializeTrustpilot();
document.addEventListener('shopify:section:load', initializeTrustpilot);
function initializeFeaturedProducts(root = document) {
  root.querySelectorAll('[data-featured-feed]').forEach(async (grid) => {
    if (grid.dataset.loading) return;
    grid.dataset.loading = 'true';
    try {
      const response = await fetch(grid.dataset.feedUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = [...parsed.querySelectorAll('.product-card')].slice(0, Number(grid.dataset.limit) || 12);
      if (cards.length) grid.replaceChildren(...cards);
    } catch { /* Keep server-rendered cards if the enhancement is unavailable. */ }
  });
}
initializeFeaturedProducts();
document.addEventListener('shopify:section:load', (event) => initializeFeaturedProducts(event.target));

// Shopify's preview toolbar uses the browser top layer, so a higher banner
// z-index cannot uncover the consent buttons. Reserve its actual visible height.
function initializePreviewBannerOffset() {
  let toolbar;
  let resizeObserver;
  let attributeObserver;
  const update = () => {
    const rect = toolbar?.getBoundingClientRect();
    const visible = rect && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight
      && getComputedStyle(toolbar).visibility !== 'hidden';
    const height = visible ? Math.max(0, Math.min(rect.height, innerHeight - rect.top)) : 0;
    document.documentElement.style.setProperty('--sq-preview-toolbar-height', `${Math.ceil(height)}px`);
    document.documentElement.toggleAttribute('data-preview-toolbar-visible', height > 0);
  };
  const connect = () => {
    const current = document.getElementById('PBarNextFrameWrapper');
    if (current !== toolbar) {
      resizeObserver?.disconnect();
      attributeObserver?.disconnect();
      toolbar = current;
      if (toolbar) {
        resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(toolbar);
        attributeObserver = new MutationObserver(update);
        attributeObserver.observe(toolbar, { attributes: true, attributeFilter: ['style', 'class', 'popover', 'hidden'] });
        toolbar.addEventListener('toggle', update);
      }
    }
    update();
  };
  new MutationObserver(connect).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', update);
  connect();
}
initializePreviewBannerOffset();
